import type { BookingStatusResponse, StatusView } from '../types';

const RETURN_HASH_KEY = 'yoga-booking-return';

export function readReturnTokenFromHash(): string | null {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) {
    return null;
  }

  const params = new URLSearchParams(hash);
  const token = params.get(RETURN_HASH_KEY);
  return token?.trim() ? token : null;
}

export function stripReturnTokenFromHash(): void {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) {
    return;
  }

  const params = new URLSearchParams(hash);
  if (!params.has(RETURN_HASH_KEY)) {
    return;
  }

  params.delete(RETURN_HASH_KEY);
  const remaining = params.toString();
  const nextUrl = remaining
    ? `${window.location.pathname}${window.location.search}#${remaining}`
    : `${window.location.pathname}${window.location.search}`;

  window.history.replaceState(null, '', nextUrl);
}

export function resolveStatusView(data: BookingStatusResponse): StatusView {
  if (data.bookingStatus === 'confirmed') {
    return 'confirmed';
  }

  if (data.bookingStatus === 'expired') {
    return 'expired';
  }

  if (
    data.bookingStatus === 'payment_failed' ||
    data.paymentStatus === 'failed' ||
    data.paymentStatus === 'canceled' ||
    data.paymentStatus === 'expired'
  ) {
    return 'failed';
  }

  return 'processing';
}

export function getReturnPath(): string {
  return `${window.location.pathname}${window.location.search}`;
}

export function getReturnOrigin(): string {
  return window.location.origin;
}
